import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Endpoint } from 'src/app/models/endpoint';
import { UrlService } from 'src/app/services/util/url.service';

@Component({
    selector: 'app-view-settings-urls',
    templateUrl: './view-settings-urls.component.html',
    styleUrls: ['./view-settings-urls.component.scss'],
    standalone: false
})
export class ViewSettingsUrlsComponent implements OnInit {

  @Input() endpoint: Endpoint;
  @Input() gitlabendpoint: Endpoint;
  @Input() showCopyUrl: boolean;
  @Output() urlCopied = new EventEmitter<any>();

  constructor(public urlService: UrlService) { }

  ngOnInit(): void {
  }

  onCopiedUrl(): void {
    this.urlCopied.emit();
  }

}
